import React from 'react';
import { NodeData } from '../../../pages/campaings/flows/types';
import Icon from '../../forms/icon.component';

interface Props {
  data: NodeData;
}

export function getFilenameFromUrl(url: string): string {
  try {
    const { pathname } = new URL(url);
    const filename = decodeURIComponent(pathname.split('/').pop() || '');
    return filename;
  } catch {
    return '';
  }
}

const DefaultBody: React.FC<Props> = ({ data }) => (
  <>
    {data.default?.text && <p className="mb-0 node-width-fit pe-2">{data.default.text.es}</p>}
    {data.default?.image && (
      <div className="node-image-container mt-2">
        <img src={data.default.image.es.link} alt="preview" />
      </div>
    )}
    {data.default?.video && (
      <div className="ratio ratio-16x9 mw-400px mt-2 ">
        <video
          controls
          className="w-100 h-100 rounded"
          controlsList="nodownload nofullscreen noremoteplayback"
        >
          <source src={data.default.video.es.link} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    )}
    {data.default?.document && (
      <div className="rounded bg-light-info py-2 mt-2 me-2 d-flex align-items-center justify-content-center">
        <Icon icon="ki-file-added" size="fs-1" type="info" />
        <small className="ms-2 fs-7 text-truncate mw-100px">
          {getFilenameFromUrl(data.default.document.es.link) || 'Documento sin título'}
        </small>
      </div>
    )}
    {data.default?.video || data.default?.document || data.default?.image ? (
      <label className="form-label mt-1">
        {data.default?.image?.es?.caption ||
          data.default?.video?.es?.caption ||
          data.default?.document?.es?.caption}
      </label>
    ) : null}
  </>
);

export default React.memo(DefaultBody);
